import * as React from 'react';

import CreditModel from 'src/model/credit.model';

import './CreditsRowDesktop.scss';
import LocaleFormating from 'src/translation/localeFormating';
import RCheckbox from 'src/components/common/RCheckbox/RCheckbox';

interface ICreditsRowProps {
  credit: CreditModel;
  onShowDetails: (e: any, payment: any) => void;
  onChangeCheckbox: (payment: any) => void;
}

interface ICreditsRowState {
  isChecked: boolean;
}

class CreditsRow extends React.Component<ICreditsRowProps, ICreditsRowState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isChecked: false
    };
  }

  public componentDidMount = () => {
    const { credit } = this.props;

    if (credit.paymentStatus === 'VOID') {
      this.setState({
        isChecked: true
      });
    }
  };

  public render() {
    return (
      <div className="row rp-credits-row">
        <div className="col-3 rp-credits-item">
          <a
            href="#"
            className="rp-credits-content --tracking-number"
            onClick={e => this.props.onShowDetails(e, this.props.credit)}
          >
            {this.props.credit.paymentId}
          </a>
        </div>
        <div className="col-2 rp-credits-item">
          <span className="rp-credits-content">
            {this.props.credit.userInformation.clientIdentity}
          </span>
        </div>
        <div className="col-2 rp-credits-item">
          <span className="rp-credits-content">
            {LocaleFormating.formatDate(this.props.credit.pmtDate, 'short')}
          </span>
        </div>
        <div className="col-2 rp-credits-item">
          <span className="rp-credits-content">
            {this.props.credit.signature}
          </span>
        </div>
        <div className="col-3 rp-credits-item">
          <RCheckbox
            id={this.props.credit.paymentId}
            onChanged={
              this.props.credit.paymentStatus !== 'PENDING'
                ? () => null
                : () => this.props.onChangeCheckbox(this.props.credit)
            }
            color={
              this.props.credit.paymentStatus !== 'PENDING' ? 'gray' : 'green'
            }
            usesLabel={true}
            label={'VOID THIS PAYMENT'}
            type={'box'}
            checked={this.state.isChecked}
            disabled={this.props.credit.paymentStatus !== 'PENDING'}
          />
        </div>
      </div>
    );
  }
}

export default CreditsRow;
